import "./TrialBadge.css";

import {
  EXPERIMENT_STATUS,
  PLOTMAP_STATUS,
  TRIAL_STATUS,
} from "../../constants";
import { useDispatch, useSelector } from "react-redux";

import { Badge } from "reactstrap";
import { CountryFlag } from "../../components/CountryFlag/CountryFlag";
import { HighlightedText } from "../../components/highlightedText/HighlightedText";
import PropTypes from "prop-types";
import { fetchResultMapFeatures } from "../../actions/resultMap";
import { useMemo } from "react";

export const TrialBadge = ({
  modeMarkers,
  trial,
  disableClick,
  highlight = "",
}) => {
  const site = useSelector(({ user }) =>
    user.contracts
      .flatMap((contract) =>
        contract.sites.map((site) => ({ ...site, contract }))
      )
      .find(({ id }) => id === trial.id)
  );
  const [selectedTrial] = useSelector(({ resultMap }) => [resultMap.trial]);

  const dispatch = useDispatch();

  const trialStatus = useMemo(() => {
    if (
      trial.experiment_status in
        [EXPERIMENT_STATUS.NOT_STARTED, EXPERIMENT_STATUS.DRAFT] ||
      trial.plotmap_status === PLOTMAP_STATUS.WAITING_FOR_VALIDATION
    )
      return TRIAL_STATUS.ACTION_REQUIRED;
    else if (
      trial.experiment_status >= EXPERIMENT_STATUS.COMPLETED &&
      trial.plotmap_status === PLOTMAP_STATUS.VALIDATED
    )
      return TRIAL_STATUS.VALIDATED;
    else return TRIAL_STATUS.IN_PREPARATION;
  }, [trial.experiment_status, trial.plotmap_status]);

  return modeMarkers ? (
    <div className="trial-marker">
      <div className="trial-info p-2">
        <div className="trial-marker-badge">
          <span className="font-style-italic me-2">{site.contract.name}</span>
          <div
            className="trial-marker-legend"
            style={{
              backgroundColor: trialStatus.color,
            }}
          >
            {trialStatus.label}
          </div>
        </div>
        <span className="d-flex flex-row gap-1 font-weight-bold text-ellipsis">
          {site.country && <CountryFlag size="sm" alpha={site.country} />}
          {trial.display_name}
        </span>
      </div>
      <div
        className="trial-marker-icon"
        style={{
          backgroundColor: trialStatus.color,
        }}
      >
        <i className="fa-solid fa-leaf" />
      </div>
    </div>
  ) : (
    <div
      className={`trial-badge clickable p-1 ${
        selectedTrial === trial ? "active" : ""
      }`}
      onClick={() => {
        if (!disableClick)
          dispatch(fetchResultMapFeatures(trial, trial.trial_dates.at(-1)));
      }}
    >
      <div className="d-flex align-items-center justify-content-between gap-1">
        <div className="trial-name d-flex gap-1 align-items-center text-ellipsis">
          <CountryFlag size="sm" alpha={site.country} />
          <span className="font-weight-bold text-ellipsis">
            <HighlightedText text={trial.display_name} highlight={highlight} />
          </span>
        </div>
        <div className="d-flex gap-1">
          <Badge className="hiphen-badge small font-style-italic">
            <i className="fa-solid fa-calendar-days discrete-icon me-1" />
            {trial.trial_dates.length}
          </Badge>
          <div
            className="d-flex align-items-center p-1 rounded"
            style={{
              backgroundColor: trialStatus.color,
            }}
          >
            {trialStatus.icon}
          </div>
        </div>
      </div>
    </div>
  );
};

TrialBadge.propTypes = {
  trial: PropTypes.shape({
    id: PropTypes.string.isRequired,
    display_name: PropTypes.string.isRequired,
    trial_dates: PropTypes.array.isRequired,
  }),
  modeMarkers: PropTypes.bool,
  disableClick: PropTypes.bool,
  highlight: PropTypes.string,
};
